// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3N6z6","container":"styles_container__2kpkN","title":"styles_title__3kQQs","wrapper":"styles_wrapper__207ar","answer":"styles_answer__e0IS4"};